import DynamicRouterView from '@/components/common/layout/DynamicRouterView.vue';

import {
  ClaimChoice,
  ClaimConfirmation,
  ClaimDeclaration,
  ClaimDetails,
  ClaimFiles,
  ClaimHome,
} from '@/components/claim';

const claim = {
  path: 'claim',
  component: DynamicRouterView,
  children: [
    { path: '', component: ClaimHome, name: 'clientClaims' },
    { path: 'type', component: ClaimChoice, name: 'clientClaimChoice' },
    { path: 'files', component: ClaimFiles, name: 'clientClaimFiles' },
    { path: 'confirmation', component: ClaimConfirmation, name: 'clientClaimConfirmation' },
    { path: 'declaration/:productId', component: ClaimDeclaration, name: 'clientClaimDeclaration' },
    { path: ':claimId', component: ClaimDetails, name: 'clientClaimDetails' },
  ],
};

export default claim;
